<template>
  <div class="coinify-callback-page">
    <gl-loader progress-spinner />
  </div>
</template>

<script>
// components
import GlLoader from '@/components/gl-loader'

export default {
  name: 'CoinifyCallbackPage',
  components: {
    GlLoader,
  },
  data() {
    return {
      interval: null,
    }
  },
  mounted() {
    this.postClosedMessage()
    this.interval = setInterval(() => {
      this.postClosedMessage()
    }, 5000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    postClosedMessage() {
      window.parent.postMessage({ type: 'COINIFY_CLOSED' }, '*')
    },
  },
}
</script>
<style scoped>
.coinify-callback-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
